import { useQuery } from '@tanstack/react-query';
import { traAdmin } from '@/lib/api/traAdminClient';
import { traNavTabs } from '@/components/tra/traNavTabs';
import ModuleLayout from '@/components/admin/ModuleLayout';
import { LoadState } from "@/components/ui/LoadState"

export default function WaitlistStatsPage() {
  const { data, isLoading } = useQuery({
    queryKey: ['tra-waitlist-stats'],
    queryFn: () => traAdmin.getWaitlistStats(),
  });

  return (
    <ModuleLayout
      breadcrumbs={[{ label: 'SateLab', to: '/' }, 'TRA', 'Estadísticas']}
      title="Estadísticas de lista de espera"
      subtitle="Antigüedad y crecimiento del backlog — sin propiedades ni dinero"
      tabs={traNavTabs('stats')}
      metrics={[
        { label: 'En espera sin asignar', value: String(data?.unassignedWaitlistSize ?? '—'), tone: 'warning' },
        {
          label: 'Crecimiento neto (año en curso)',
          value: data ? String(data.netWaitlistGrowth.netGrowth) : '—',
          tone: data && data.netWaitlistGrowth.netGrowth > 0 ? 'warning' : 'good',
          hint: 'Nuevas solicitudes menos las asignadas a una edición',
        },
      ]}
    >
      {isLoading && <LoadState />}
      {!isLoading && data && (
        <div className="space-y-6">
          <section className="rounded-xl border border-gray-200 dark:border-gray-700 p-5">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
              Próxima edición programada
            </h3>
            {data.nextEdition ? (
              <p className="text-sm text-gray-700 dark:text-gray-300">
                {data.nextEdition.name} — cierre de inscripciones{' '}
                {new Date(data.nextEdition.registrationDeadline).toLocaleDateString('es-CO')}
              </p>
            ) : (
              <p className="text-sm text-gray-500">No hay ninguna edición próxima programada.</p>
            )}
          </section>

          <section className="rounded-xl border border-gray-200 dark:border-gray-700 p-5">
            <h3 className="font-semibold text-gray-900 dark:text-white mb-3">
              Antigüedad de la lista de espera sin asignar (más antiguas primero)
            </h3>
            {data.waitlistAging.length === 0 ? (
              <p className="text-sm text-gray-500">No hay solicitudes sin asignar.</p>
            ) : (
              <ul className="space-y-2 text-sm">
                {data.waitlistAging.slice(0, 20).map((w) => (
                  <li key={w.waitlistEntryId} className="flex justify-between">
                    <span>{w.fullName}</span>
                    <span className="text-gray-500">{w.daysWaiting}d esperando</span>
                  </li>
                ))}
              </ul>
            )}
          </section>
        </div>
      )}
    </ModuleLayout>
  )
}
